import { render } from "./UndefinedPhotoIconVisualisator.vue?vue&type=template&id=084b1515"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__